module.exports = __webpack_public_path__ + "static/media/13.7bd6f428.png";